import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js'
import index from '../../../utils/index'

export default {
  name: 'trip-generate-connection-print',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      isLoading: false,
      isLoadingSearch: false,
      showTable: true,
      ConnectionDetails: {},
      ManifestDetails: [],
      ClientName: '',
      ManifestNumber: '',
      ScheduleDate: '',
      ScheduleId: '',
      printDate: '',
      printBy: '',
      isDisplay: false,
      showemailpage:false,
      emailIdErrorMSG:'',
      emailIdValidationMSG:'',
      mailId:'',
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      printConfig : false,
      isHidePrintManifestReport:false
    }
  },
  created: function() {},
  model: {},
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    TotalMRP: function(data) {
      var resultMRP;
      for (var i = 0; i < data.length; i++) {
        resultMRP = data[i].MRP
      }
      if (resultMRP == null) {
        return 0
      }
      var total = data.reduce(function(totalMRP, item) {
        return totalMRP + parseFloat(item.MRP);
      }, 0);
      var with2Decimals = total.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      return with2Decimals
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email.toLowerCase()
    this.pageName = localStorage.getItem('pageName');
  },
  methods: {
    showManifest(type) {
      this.getConnectionDetails();
      if(type=="Mongo" || type=="Backup"){
        this.getManifestDetails(type);
      }
    //   else{
    //   this.getManifestDetails();
    // }
    },
    getConnectionDetails() {
      if (this.$route.params.CSMID ) {
        var csmid = this.$route.params.CSMID;
        var connectiontype = this.$route.params.connectiontype;
        this.isLoading = true
        this.printConfig = false;

        this.input = {
          CSMID: parseInt(csmid),
          ConnectionType : parseInt(connectiontype)
        }
        this.isLoadingSearch = true;
        axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetConnectionDetailsByCSMID',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.ResultCode == 100) {
              this.printConfig =  index.configRolesCheck(result.data.config.pr_web_roles);
              // if(!this.printConfig) {
              //   this.$alertify.error("No Printing Access");
              //   return;
              // }
              this.isDisplay = true;
              this.ConnectionDetails = result.data.ResponseData;
              // this.loadShipmentsDetails(this.$route.params.LineHaulDetailsID, this.$route.params.ConfirmLineHaulDetailsID)
            } else if (result.data.ResultCode == 103 || result.data.ResultCode == 102) {
              this.isDisplay = false;
              this.ConnectionDetails = {};
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.isDisplay = false;
              this.ConnectionDetails = {};
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.isLoading = false
          }, error => {
            this.isDisplay = false
            this.isLoading = false
            this.isLoadingSearch = false;
            console.error(error)
          })
      } else {
        this.$alertify.error("Somethig wrong, Try again");
      }
      this.isDisplay = false
    },
    getManifestDetails(type) {
      if (this.$route.params.CSMID) {
        var csmid = this.$route.params.CSMID;
        this.isLoading = true
        this.input = {
          CSMID: parseInt(csmid)
        }
        if(type=="Mongo"){
          var url = 'getPrintManifestDetailsForTripNewAPI?connectionSchedulemasterId=' + csmid
        }else if(type=="Backup"){
          var url = 'getPrintManifestDetailsForTripNewAPI_v1?connectionSchedulemasterId=' + csmid
        }
        // else{
        //   var url = 'getPrintManifestDetailsForTrip?connectionSchedulemasterId=' + csmid
        // }
        this.isHidePrintManifestReport = false;
        this.isLoadingSearch = true;
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + url,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.ResultCode == 100) {
              // Hide Print Manifest Report View based on Flag
              this.isHidePrintManifestReport = result.data.isHidePrintManifestReport;

              if (result.data.ReturnData.shipmentDetails.length > 0) {
                this.ManifestDetails = result.data.ReturnData.shipmentDetails;
              } else {
                this.$alertify.error("shipmentDetails are empty");
              }
            } else if (result.data.ResultCode == 103) {
              this.isDisplay = false;
              this.ManifestDetails = [];
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.isDisplay = false;
              this.ManifestDetails = [];
              this.$alertify.error(result.data.ReturnMessage + " Of Manifest")
            }
            this.isLoading = false
          }, error => {
            this.isDisplay = false
            this.isLoading = false
            this.isLoadingSearch = false;
            console.error(error)
          })
      } else {
        this.$alertify.error("Somethig wrong, Try again");
        this.isLoading = false
      }
      this.isDisplay = false
      this.isLoading = false
    },
    printManifest() {
      const d = new Printd();
      var buffer = '';
      this.isLoadingSearch = true;
        this.input = {
        "currentHubId" : Number( this.$route.params.hubid),
        "tripId" : Number(String(this.$route.params.CSMID).trim()),
        "createdBy" : this.printBy,
        "reportName" : 'Print Manifest',
        "pageName" : this.pageName
      }
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'printGatePass',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
         this.isLoadingSearch = false;
        if(result.data.ResultCode == 100) {
          this.alertify.success(result.data.ReturnMessage);
        } else {
          this.alertify.error(result.data.ReturnMessage);
				}
      })
      .catch((error) => {
        this.isLoadingSearch = false;
        this.alertify.error(error);
        console.log(error)
      });

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:2px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .td-width{
             width:10px!important;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
            .print-only {
              display: block;
            }
            .no-print {
              display: none !important;
            }
          }
          `
      d.print(document.getElementById('printManifestContent'), cssText);
    },
    toFixedVal(val) {
      // console.log(val);
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
    sendMail(){
      console.log(1);
      this.showemailpage=true;
    },
    closeSendMailPage(){
      this.showemailpage = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.resetFormForMail();
    },
    resetFormForMail(){
      this.mailId='',
      this.emailIdErrorMSG='',
      this.emailIdValidationMSG=''
    },
    SendMailFunction(){
      this.emailIdValidationMSG=''
      this.emailIdErrorMSG=''
      var CSMID='';
      var ConnectionType='';
      if (this.$route.params.CSMID ) {
        console.log(11);
        CSMID = this.$route.params.CSMID;
        ConnectionType = this.$route.params.connectiontype;
        CSMID=parseInt(CSMID),
        ConnectionType =parseInt(ConnectionType)
      }
      if(this.mailId =='' || this.mailId == undefined)
      {
        this.emailIdErrorMSG="Enter Email-Id"
        return false
      }
      var mailArray=[];
      mailArray = this.mailId.split(',');
      for(var i=0;i<mailArray.length;i++)
    {
      if(this.regForMail.test(mailArray[i]) == false)
      {
        this.emailIdValidationMSG="Invalid MailId"+" "+mailArray[i]
        return false
      }
    }
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'emailTripManifestDetails?connectionSchedulemasterId=' + CSMID + '&emailId=' + this.mailId + '&createdBy=' + this.createdBy +'&connectionType=' + ConnectionType,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        }).then(result => {
          var response = result.data
          if (response.ResultCode == 100) {
            this.$alertify.success(response.ReturnMessage)
            this.resetFormForMail()
            this.closeSendMailPage()
          } else {
            this.$alertify.error(response.ReturnMessage)
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    downloadPDF(){
      document.body.classList.add('pdf-mode');
     var element = document.getElementById('printManifestContent');
     var opt = {
         margin: [20, 20, 20, 20],
         filename: "PrintManifest",
         image: { type: 'jpeg', quality: 0.98 },
         html2canvas: { scale: 2 },
         jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
     };

     html2pdf().set({
         pagebreak: { mode: 'avoid-all', inside: "avoid", before: '#page2el' }
     }).set(opt).from(element).save().then(() => {
        document.body.classList.remove('pdf-mode'); // cleanup
      });
    }

  },
}



// WEBPACK FOOTER //
// ./src/views/components/TripGenerateConnectionPrint/TripGenerateConnectionPrint.js